import { QuoteModel } from 'models/quote';

export function getProductPayload(quote: QuoteModel, group: string, productSelected: number[]) {
  const orderProduct = quote.orderproducts.filter((prod) => productSelected.includes(prod.id));
  return orderProduct.map(prod => ({ ...prod, id: undefined, group }));
}
